import { render, staticRenderFns } from "./Desktop.vue?vue&type=template&id=05331b2a&scoped=true&"
import script from "./Desktop.vue?vue&type=script&lang=ts&"
export * from "./Desktop.vue?vue&type=script&lang=ts&"
import style0 from "./Desktop.vue?vue&type=style&index=0&id=05331b2a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05331b2a",
  null
  
)

export default component.exports